import { useAuthStore, isAdminRole, homeFor, type User } from "../store/auth";

export type AuthResponse = { user: User; access_token: string };

/**
 * ログイン・招待受け取りの返事を受けて、管理画面に入れる人だけ保存する。
 * 学習者・役割なしはトークンを捨てて null を返す（呼ぶ側が login-error を出す）。
 */
export function acceptSession(data: AuthResponse): string | null {
  const role = data?.user?.role ?? null;
  if (!data?.access_token || !isAdminRole(role)) {
    useAuthStore.getState().clear();
    return null;
  }
  useAuthStore.getState().setAuth(data.access_token, { ...data.user, role, org_id: data.user.org_id ?? null });
  return homeFor(role);
}

/** 招待リンク（API の path）を画面に出す URL にする */
export function inviteUrlFrom(res: { token?: string; path?: string }): string {
  const path = res.path ?? (res.token ? `/invite/${res.token}` : "");
  return path ? `${window.location.origin}${path.startsWith("/") ? path : `/${path}`}` : "";
}
